import { customApiErrors } from './api.custom.errors';

export const handleCustomApiErrors = (error) => {
  switch (true) {
    case error instanceof customApiErrors.AbortableRequestError: {
      break;
    }
    default:
      throw error;
  }
};

export const apiHelpers = {
  handleCustomApiErrors,
};
